import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconExclamationCircleBold: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconExclamationCircleBold"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M11.5 13.5L11.25 7H12.75L12.5 13.5H11.5Z" fill="currentColor"/><Circle cx="12.0001" cy="15.9996" r="0.9" fill="currentColor"/></CentralIconBase>;
});

export default IconExclamationCircleBold;
